import { Box, Typography, CircularProgress } from '@mui/material'
import { useEffect, useState } from 'react'
import BedtimeIcon from '@mui/icons-material/Bedtime'
import useEarnings from '../hooks/useEarnings'

const Deductions = () => {
  const { fetchDeductionsUrl } = useEarnings()
  const [deductionsUrl, setDeductionsUrl] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const updateDeductionsUrl = async () => {
      setIsLoading(true)
      const url = await fetchDeductionsUrl()
      setDeductionsUrl(url)
      setIsLoading(false)
    }

    updateDeductionsUrl()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const urlValid = (url: string | null) =>
    typeof url === 'string' && url.length > 0

  const styles = {
    container: {
      display: 'flex',
      width: '100%'
    },
    deductionsIframe: {
      width: '90%',
      height: '700px',
      margin: '20px 0',
      border: 'none'
    },
    noPBLMessage: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '700px'
    },
    bedtimeIcon: {
      fontSize: 120,
      mb: 2,
      color: 'text.secondary'
    },
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '700px'
    }
  }

  if (isLoading) {
    return (
      <Box sx={styles.loadingContainer}>
        <CircularProgress size={60} />
      </Box>
    )
  }

  return (
    <Box sx={styles.container}>
      {urlValid(deductionsUrl) ? (
        <iframe
          role="looker-deductions"
          src={deductionsUrl as string}
          style={styles.deductionsIframe}
        />
      ) : (
        <Box sx={styles.noPBLMessage}>
          <BedtimeIcon sx={styles.bedtimeIcon} />
          <Typography align="center">
            This view has been automatically disabled due to inactivity.
            <br />
            Please reach out to your account manager if you would like to
            re-enable it.
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default Deductions
